// Core Modules
import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';

// Components
import { AppComponent } from '@app/app.component';

// Environment
import { environment } from '@env/environment';

// Configs
import { appConfig } from '@app/app.config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
